import { AuthLayout, PublicLayout, ProtectedLayout, UserOnboardingLayout } from 'src/layouts';
import { TLayoutRoute } from 'src/types/routes.types';
import {
  EmailVerification,
  ForgotPassword,
  LandingPage,
  Login,
  OnboardingUserType,
  SetNewPassword,
  SignUp,
  TellMeMore,
  ForceChangePassword,
  AccessDenied,
  PageNotFound,
  ApplyToProgram,
  Dashboard,
  Resources,
  ViewProfile,
  ViewCompany,
  ViewPostSingle,
  EditIdea
} from 'src/pages';

import { renderRoutes } from './generate-routes';
import getProtectedRoutes from './getProtectedRoutes';
import SuccessScreen from 'src/components/common/SuccessScreen/SuccessScreen';
import CheckPassword from 'src/pages/check-password';
import RatingSection from 'src/components/company/programs/ApplicationRating/RatingSection/RatingSection';
import ApplyToProgramExternal from 'src/pages/applyToProgramExternal/ApplyToProgramExternal';
import KeyMemberVerification from 'src/pages/KeyMemberVerification/KeyMemberVerification';
import Feedback from 'src/pages/feedback/feedback';
import PublicSurveyReportForm from 'src/components/company/programs/Cohorts/PublicSurveyReportForm';
import RatingResponses from 'src/components/company/programs/Cohorts/ApplicationRating/RatingResponses/RatingResponses';
import AllMarketPlaceProduct from 'src/pages/AllMarketplaceProduct/AllMarketPlaceProduct';
import ForInvestors from 'src/pages/landingPage/forInvestors/ForInvestors';
import MarketPlace from 'src/pages/MarketPlace/MarketPlace';
import ApplyToEventExternal from 'src/pages/ApplyToEvent/ApplyToEventExternal';
import Discover from 'src/pages/discover/discover';
import Venture from 'src/pages/venture/Venture';
import PostVenture from 'src/pages/post-venture/PostVenture';
import VentureDetailPage from 'src/pages/venture-detail/ventureDetailPage';
import MyVentureDetail from 'src/pages/my-venture/MyVenture';
import DemoDay from 'src/pages/demo-day/DemoDay';
import PrivacyPolicy from 'src/pages/landingPage/privacy-policy/PrivacyPolicy';
import PaymentPolicy from 'src/pages/landingPage/payment-policy/PaymentPolicy';
import IdeaHub from 'src/pages/ideahub-simple/IdeaHub';
import ContactUs from 'src/pages/contact-us/ContactUs';
import ScoreCard from 'src/pages/score/ScoreCard';
import ScoringEngineLandingPage from 'src/pages/ScoringEngineLandingPage/ScoringEngineLandingPage';
import NewLandingPage from 'src/pages/NewLandingPage/NewLandingPage';
import InvestorLogin from 'src/pages/investor-login/InvestorLogin';
import LatestLandingPage from 'src/pages/latestLandingPage/latestLandingPage';
export const routes: TLayoutRoute[] = [
  {
    layout: PublicLayout,
    isPublic: true,
    routes: [
      {
        name: 'home-page',
        title: 'Home page',
        component: LatestLandingPage,
        path: '/',
        availableToUserType: 'All'
      },
      {
        name: 'access-denied',
        title: 'Access Denied',
        component: AccessDenied,
        path: '/access-denied',
        availableToUserType: 'All'
      },
      {
        name: 'Success',
        title: 'Success',
        component: SuccessScreen,
        path: '/success',
        availableToUserType: 'All'
      },
      {
        name: 'KeyMemberVerification',
        title: 'KeyMemberVerification',
        component: KeyMemberVerification,
        path: '/keymember-verification',
        availableToUserType: 'All'
      },
      {
        name: 'apply-to-program-external',
        title: 'Apply to External Program',
        component: ApplyToProgramExternal,
        path: '/apply-to-program-external',
        availableToUserType: 'All'
      },
      {
        name: 'apply-to-event-external',
        title: 'Apply to Event',
        component: ApplyToEventExternal,
        path: '/apply-to-event-external',
        availableToUserType: 'All'
      },
      {
        name: 'feedback',
        title: 'Feedback',
        component: Feedback,
        path: '/feedback',
        availableToUserType: 'All'
      },
      {
        name: 'Check Password',
        title: 'Check Password',
        component: CheckPassword,
        path: '/check-password',
        availableToUserType: 'All'
      },
      {
        name: 'Application Rating',
        title: 'application rating',
        component: RatingSection,
        path: '/application-rating',
        availableToUserType: 'All'
      },
      {
        name: 'apply-to-program',
        title: 'Apply Program',
        component: ApplyToProgram,
        path: '/apply-to-program',
        availableToUserType: 'All'
      },
      {
        name: 'survey-report',
        title: 'Survey Report',
        component: PublicSurveyReportForm,
        path: '/survey-report',
        availableToUserType: 'All'
      },
      // new public routes
      {
        name: 'dashboard',
        title: 'Dashboard',
        // component: Dashboard,
        component: NewLandingPage,
        path: '/dashboard',
        availableToUserType: 'All'
      },
      {
        name: 'discover',
        title: 'Discover',
        component: Discover,
        path: '/discover',
        availableToUserType: 'All'
      },
      {
        name: 'venture',
        title: 'Venture',
        component: Venture,
        path: '/venture',
        availableToUserType: 'All'
      },
      {
        name: 'venture detail',
        title: 'Venture Detail',
        component: VentureDetailPage,
        path: '/view-venture',
        availableToUserType: 'All'
      },
      {
        name: 'post-venture',
        title: 'Post Venture',
        component: PostVenture,
        path: '/post-venture',
        availableToUserType: 'All'
      },
      {
        name: 'marketplace',
        title: 'MarketPlace',
        component: MarketPlace,
        path: '/marketplace',
        availableToUserType: 'All'
      },
      // {
      //   name: 'idea-hub',
      //   title: 'Idea Hub',
      //   component: IdeaHub,
      //   path: '/idea-hub',
      //   availableToUserType: 'User'
      // },
      {
        name: 'idea-hub',
        title: 'Idea Hub',
        component: IdeaHub,
        path: '/idea-hub',
        availableToUserType: 'User'
      },
      {
        name: 'edit-idea',
        title: 'edit Idea',
        component: EditIdea,
        path: '/edit-idea',
        availableToUserType: 'User'
      },
      {
        name: 'resources',
        title: 'Resources',
        component: Resources,
        path: '/resources',
        availableToUserType: 'All'
      },
      {
        name: 'view-profile',
        title: 'View Profile',
        component: ViewProfile,
        path: '/view-profile',
        availableToUserType: 'All'
      },
      {
        name: 'view-company',
        title: 'View Company',
        component: ViewCompany,
        path: '/view-company',
        availableToUserType: 'All'
      },
      {
        name: 'all-Products',
        title: 'All Products',
        component: AllMarketPlaceProduct,
        path: '/all',
        availableToUserType: 'All'
      },
      {
        name: 'for-investor',
        title: 'Investor',
        component: ForInvestors,
        path: '/for-investors',
        availableToUserType: 'All'
      },
      /* {
        name: 'investors',
        title: 'Investors',
        component: Investors,
        path: '/Investors',
        availableToUserType: 'All'
      }, */
      {
        name: 'contact-us',
        title: 'Contact-Us',
        component: ContactUs,
        path: '/contact-us',
        availableToUserType: 'All'
      },
      {
        name: 'privacy-policy',
        title: 'Privacy Policy',
        component: PrivacyPolicy,
        path: '/privacy-policy',
        availableToUserType: 'All'
      },
      {
        name: 'payment-policy',
        title: 'Payment Policy',
        component: PaymentPolicy,
        path: '/payment-policy',
        availableToUserType: 'All'
      },
      {
        name: 'view-post',
        title: 'View Post',
        component: ViewPostSingle,
        path: '/view-post',
        availableToUserType: 'All'
      },
      {
        name: 'Demo Day',
        title: 'Demo Day',
        component: DemoDay,
        path: '/demo-day',
        availableToUserType: 'All'
      },
      {
        name: 'Scoring Engine',
        title: 'Scoring Engine',
        component: ScoringEngineLandingPage,
        path: '/scoring-engine',
        availableToUserType: 'All'
      },
      {
        name: 'New Landing Page',
        title: 'New Landing Page',
        component: NewLandingPage,
        path: '/newpage',
        availableToUserType: 'All'
      }
    ]
  },
  {
    layout: AuthLayout,
    isPublic: true,
    routes: [
      {
        name: 'login',
        title: 'Login page',
        component: Login,
        path: '/login',
        availableToUserType: 'All'
      },
      {
        name: 'sign up',
        title: 'Sign up page',
        component: SignUp,
        path: '/sign-up',
        availableToUserType: 'All'
      },
      {
        name: 'investor-login',
        title: 'Investor Login page',
        component: InvestorLogin,
        path: '/investor-login',
        availableToUserType: 'All'
      },
      {
        name: 'email-verification',
        title: 'Email Verification',
        component: EmailVerification,
        path: '/email-verification',
        availableToUserType: 'All'
      },
      {
        name: 'forgot-password',
        title: 'Forgot Password',
        component: ForgotPassword,
        path: '/forgot-password',
        availableToUserType: 'All'
      },
      {
        name: 'set-new-password',
        title: 'Set New Password',
        component: SetNewPassword,
        path: '/set-new-password',
        availableToUserType: 'All'
      },
      {
        name: 'force-change-password',
        title: 'Force Change Password',
        component: ForceChangePassword,
        path: '/force-change-password',
        availableToUserType: 'All'
      }
    ]
  },
  {
    layout: UserOnboardingLayout,
    routes: [
      {
        name: 'onboarding-user-type',
        title: 'Onboarding User Type',
        component: OnboardingUserType,
        path: '/onboarding-user-type',
        availableToUserType: 'All'
      },

      {
        name: 'tell-me-more',
        title: 'Tell Me More',
        component: TellMeMore,
        path: '/tell-me-more',
        availableToUserType: 'All'
      },
      {
        name: 'blogs',
        title: 'blogs',
        component: TellMeMore,
        path: '/blogs',
        availableToUserType: 'All'
      }
    ]
  },
  {
    layout: ProtectedLayout,
    routes: getProtectedRoutes
  },
  {
    layout: PublicLayout,
    routes: [{ name: 'not-found', title: 'Not found', component: PageNotFound, path: '*' }]
  },
  {
    layout: PublicLayout,
    routes: [{ name: 'Success', title: 'Success', component: SuccessScreen, path: '/success' }]
  },
  {
    layout: PublicLayout,
    routes: [{ name: 'apply-to-program', title: 'Apply Program', component: ApplyToProgram, path: '/apply-to-program' }]
  },
  {
    layout: PublicLayout,
    routes: [{ name: 'Check Password', title: 'Check Password', component: CheckPassword, path: '/check-password' }]
  },
  {
    layout: PublicLayout,
    routes: [{ name: 'Application Rating', title: 'application rating', component: RatingSection, path: '/application-rating' }]
  }
];

export const Routes = renderRoutes(routes);
